import { useCallback, useRef, useState } from 'react';
import '../Analitos.scss';
import { useApiConfiguration } from '../../../api/api.configuration';
import { Button, ScrollView, Tooltip } from 'devextreme-react';
import Toolbar, { Item as ToolbItem } from 'devextreme-react/toolbar';
import { formatMessage } from 'devextreme/localization';
import { Form, Item, Label } from 'devextreme-react/form';

export const ReferencesText = ({ IdAnalito, ValRefText }: { IdAnalito: number; ValRefText: any }) => {
  const { UpdateValRefTextAsync } = useApiConfiguration();
  const formRef = useRef<Form>(null);
  const [EditItem, setEditItem] = useState<boolean>(true);

  const handleEditClick = useCallback(() => {
    setEditItem(false);
    formRef.current?.forceUpdate();
  }, [IdAnalito]);

  const handleSaveClick = useCallback(() => {
    UpdateValRefTextAsync(IdAnalito, ValRefText)
      .then((res) => {
        if (res === 107) {
          setEditItem(true);
        }
      })
      .catch(() => {
        throw new Error('Error actualizando el texto de referencia');
      });
  }, [IdAnalito, ValRefText]);

  function screenByWidth(width) {
    return width < 720 ? 'sm' : 'md';
  }

  return (
    <div>
      <ScrollView className='view-wrapper-scroll' width={'100%'}>
        <Toolbar className='toolbar-common'>
          <ToolbItem location='after' locateInMenu='auto' widget='dxButton' showText='inMenu'>
            <Button id='toolBarEdit' text={formatMessage('toolBarEdit')} stylingMode='outlined' icon='edit' type='default' onClick={handleEditClick} />
          </ToolbItem>
          <ToolbItem location='after' locateInMenu='auto' widget='dxButton' showText='inMenu'>
            <Button id='toolBarSave' text={formatMessage('toolBarSave')} stylingMode='outlined' icon='save' type='default' onClick={handleSaveClick} />
          </ToolbItem>
        </Toolbar>
        <div className='formStyle'>
          <form>
            <Form formData={ValRefText} ref={formRef} labelLocation='top' minColWidth={233} colCount='auto' screenByWidth={screenByWidth} colCountByScreen={{ sm: 1, md: 2 }}>
              <Item key={`${IdAnalito}_valref`} editorType='dxTextBox' dataField='An_ValRefText' disabled={EditItem}>
                <Label>TEXTO DE REFERENCIA</Label>
              </Item>
              <Item key={`${IdAnalito}_valcritico`} editorType='dxTextBox' dataField='An_ValCritico' disabled={EditItem}>
                <Label>TEXTO CRÍTICO</Label>
              </Item>
            </Form>
          </form>
        </div>
      </ScrollView>
      <Tooltip showEvent='mouseenter' hideEvent='mouseleave' position={'top'} target={'#toolBarSave'}>
        {formatMessage('toolBarSave')}
      </Tooltip>
      <Tooltip showEvent='mouseenter' hideEvent='mouseleave' position={'top'} target={'#toolBarEdit'}>
        {formatMessage('toolBarEdit')}
      </Tooltip>
    </div>
  );
};
